import reduxStore from '../../redux/store'
import { hasPermission } from '../../lib/components/form/RestrictedComponent'
import getPathValue from '../../utils/getPathValue'
import schema from './schema'

const getPermissionMap = (route) => ({
  manage: {
    ott: {
      edit: schema.MANAGE_OTT.UPDATE,
      default: schema.MANAGE_OTT.READ,
      roku: schema.MANAGE_OTT.UPDATE
    },
    ads: {
      edit: schema.MANAGE_ADS.UPDATE,
      default: schema.MANAGE_ADS.READ,
      analytics: schema.MANAGE_ADS.READ
    },
    listing: {
      edit: `${schema.MANAGE_CLIENT_CHANNEL_SETTINGS.READ},${schema.MANAGE_CLIENT_CHANNEL_SETTINGS.CREATE}`,
      default: schema.MANAGE_CLIENT_CHANNEL_SETTINGS.READ
    },
    player: {
      default: schema.MANAGE_CLIENT_PLAYER_SETTINGS.READ,
      edit: `${schema.MANAGE_CLIENT_PLAYER_SETTINGS.READ},${schema.MANAGE_CLIENT_PLAYER_SETTINGS.UPDATE}`,
    },
    technicians: {
        schedule: schema.MANAGE_CLIENT_TECHNICIANS.READ,
        default: schema.MANAGE_CLIENT_TECHNICIANS.READ,
    },
    media: schema.MANAGE_CLIENT_GLOBAL_MEDIA.READ,
    encoders: schema.MANAGE_CLIENT_ENCODERS.READ,
    vocab: true, // removed () => reduxStore.getState().data.client.VTTaccess === true,
    default: route[1] ? (route[1] && 'manage_client_' + route[1] + '.read') : true,
  },
  sourceMultiViewer: schema.MANAGE_CLIENT_ENCODERS.READ,
  agenda: schema.AGENDA_EVENT.READ,
  import: schema.EVENT_IMPORTER.READ,
  events: {
    default: route[1] && route[1] === 'create' ? `${schema.EVENT.READ},${schema.EVENT.CREATE}` :  schema.EVENT.READ,
  },
  editor: schema.EVENT_VIDEO_EDITOR.READ,
  securityGroups: schema.ACCOUNT_SECURITY_GROUPS.READ,
  contentGroups: schema.ACCOUNT_CONTENT_GROUPS.READ,
  status: true,
  'release-notes': true,
  login: true,
  logout: true,
  help: true,
  admin: true,
  default: route[0] + '.read',
})

/**
 *
 * @param {string[]} route array of string broken up by route path '/'
 * @example: 'manage/listing/edit' => ['','manage','listing','edit']
 * @returns {boolean} whether the user is authorized to access this route based on given permissions
 */
const hasRoutePermissionNew = (route) => {
  const permissionMap = getPermissionMap(route)
  let mapPath
  try {
    mapPath = getMapPath(permissionMap, route)
  } catch (err){
    console.error(err)
    return false
  }
  const permission = getPathValue(mapPath, permissionMap)
  return hasPermission(permission)
}

const getMapPath = (map, route) => {
  // get the route path through the map
  if (route.length && map.hasOwnProperty(route[0])) {
    const deeperPath = getMapPath(map[route[0]], route.slice(1))
    return deeperPath !== '' ? `${route[0]}.${deeperPath}` : route[0]
  } else if (
    (route.length === 0 && map.hasOwnProperty('default')) ||
    (route.length && !map.hasOwnProperty(route[0]))
  ) {
    // use default when no path is found
    return `default`
  } else if (
    route.length === 0 &&
    (typeof map === 'string' ||
      typeof map === 'boolean' ||
      typeof map === 'function')
  ) {
    return ''
  } else {
    // route has more path but no more map and map has no default for the previous path
    throw new Error('Route permissions error: no matching map path')
  }
}

const hasRoutePermission = (route) => {
  const oldRoute = ['', ...route]
  const routePermissionMap = getPermissionMap(route)
  let permissionMapKeys = []
  if (oldRoute[1] && routePermissionMap[oldRoute[1]]) {
    permissionMapKeys.push(oldRoute[1])
  } else {
    permissionMapKeys.push('default')
  }

  if (oldRoute[2] && routePermissionMap[permissionMapKeys[0]][oldRoute[2]]) {
    permissionMapKeys.push(oldRoute[2])
  } else if (routePermissionMap[permissionMapKeys[0]].default) {
    permissionMapKeys.push('default')
  }

  //  3rd route check can have no route to match on but may have a default check
  //  ex: 'manage/listing/edit' vs 'manage/listing'
  if (oldRoute[3] && routePermissionMap[permissionMapKeys[0]][permissionMapKeys[1]]) {
    permissionMapKeys.push(oldRoute[3])
  } else if (
    (typeof routePermissionMap[permissionMapKeys[0]][permissionMapKeys[1]] === 'object' ||
      typeof routePermissionMap[permissionMapKeys[0]][permissionMapKeys[1]] === 'undefined') &&
    typeof routePermissionMap[permissionMapKeys[0]][permissionMapKeys[1]] === 'object' &&
    permissionMapKeys[permissionMapKeys.length - 1] !== 'default'
  ) {
    permissionMapKeys.push('default')
  }

  const checkedRoutePermission = hasPermission(
    getPathValue(permissionMapKeys.join('.'), routePermissionMap)
  )
  if (checkedRoutePermission !== hasRoutePermissionNew(route)) {
    console.error(
      `Route permissions error: hasRoutePermission and hasRoutePermissionNew do not match for route ${oldRoute}`, checkedRoutePermission, hasRoutePermissionNew(route)
    )
  }
  return checkedRoutePermission
}

export default hasRoutePermission
